import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';

export const setListAttendeesPageSize = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<'10' | '25' | '50' | '100'>((state, action) => {
    state.listAttendees.pageSize = action.payload;
    state.listAttendees.page = 1;
  });
